import LabeledInput from './LabeledInput';
export default LabeledInput;
